import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import settings from 'src/config/settings'

export const exportPartnersCoverage = async (fYear: number): Promise<Blob | null> => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const url = `${serviceUrl}/api/v0/reporting/exportPartnersCoverage`

  const [accessToken] = getTokens()

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...(accessToken ? { Authorization: accessToken } : {}),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ fYear }),
    })

    if (!response.ok) {
      return null
    }

    return await response.blob()
  } catch (e) {
    Logger.error(e)
    return null
  }
}
